import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Box } from 'atoms';

const BreadContainer = styled.div`
	display: flex;
	padding: 0 24px;
	align-items: center;
	font-weight: 300;
	font-size: 14px;
	flex: 1;
`;

const LinkText = styled(Link)`
	color: ${(props) => props.theme.colors.breadcrumb};
	letter-spacing: 0.5px;
	color: rgb(9, 23, 68);
	font-size: 1.5rem;
	width: 80%;
	font-weight: 600;
	margin-left: 1.25rem;
	&:hover {
		color: ${(props) => props.theme.colors.breadcrumbHover};
	}
`;

export default function BreadCrumbs({ urls = {} }) {
	const navigate = useNavigate();
	const location = useLocation();

	const handleClick = () => {
		if (urls?.storeFormData) {
			window.dispatchEvent(new CustomEvent('breadcrumb-back-click'));
			return;
		}
		if (location.state?.wizardStep > 0) {
			navigate(-1);
			return;
		}
		if (location.state?.from) {
			navigate(location.state.from);
		} else if (urls?.isGoBack) {
			navigate(-1);
		} else if (urls?.link) {
			navigate(urls.link);
		}
		// If no link is provided, do nothing (for non-clickable breadcrumbs)
	};

	return (
		<BreadContainer>
			{urls?.hasArrow && (
				<Box
					style={{ cursor: 'pointer' }}
					onClick={handleClick}
					fontSize="1.5rem"
					as="span"
				>
					<ArrowLeftOutlined />
				</Box>
			)}
			<LinkText
				className="menuText"
				as="span"
				onClick={urls?.link ? handleClick : undefined}
				style={{ cursor: urls?.link ? 'pointer' : 'default' }}
			>
				{urls?.text}
			</LinkText>
		</BreadContainer>
	);
}

BreadCrumbs.propTypes = {
	urls: PropTypes.shape({
		id: PropTypes.number,
		text: PropTypes.string,
		link: PropTypes.string,
		isGoBack: PropTypes.bool,
	}),
};
